import React from 'react'
import styled from 'styled-components'

import '../styles/spectre.css';

const InputDropdownQuotes = styled.div`

.form-group.es-i-template {

  font-family: "Open Sans";


  label.form-label {
    margin-bottom: 5px;
    font-weight: 700;
    color: #666;
    font-size: 14px;
    font-weight: 600;
    width: 70%;

    span {
      color: #26c1fb;
    }
  }
}

`;

const EchoShipInput = (props) => {
  return (
    <InputDropdownQuotes>
        <div className="form-group es-i-template"
        style={{
          width: "80%"
        }}
        >
        <label className="form-label" htmlFor="input-example-1">
          {props.labelTitle}
        </label>
        <select className="form-select select-lg">
          <option>Created Date (Most to Least Recent)</option>
          <option>Created Date (Least to Most Recent)</option>
          <option>Carrier (A-Z)</option>
          <option>ID (High-Low)</option>
          <option>EST. Price (Low-High)</option>
        </select>
        </div>
    </InputDropdownQuotes>
  )
}

export default EchoShipInput;